import { toNativeDate } from "@/common/utils/date";
import { getSubtramiteConfig, SubtramiteConfig } from "./getConfig";
import { SubtramiteKey, SubtramiteObject } from "./types";

const extractSubtramiteFromTramite = (config: SubtramiteConfig, tramite: any): any => {
  if ('selector' in config && typeof config.selector === 'function') {
    return config.selector(tramite);
  }

  if ('key' in config && config.key in tramite) {
    return tramite[config.key];
  }


  throw new Error(`Subtramite configuration for key or selector not found: ${JSON.stringify(config)}`);
}

const mapSubtramite = (config: SubtramiteConfig, subtramite: any): SubtramiteObject => {
  if (!subtramite) {
    return null;
  }

  return {
    ...subtramite,
    fecini: toNativeDate(subtramite.fecini),
    createdAt: toNativeDate(subtramite.createdAt),
    updatedAt: toNativeDate(subtramite.updatedAt),
    label: typeof config.label === 'function' ? config.label(subtramite) : config.label,
  }
}

export const getSubtramiteFromTramite = (key: SubtramiteKey, tramite: any): any => {
  const subtramiteConfig = getSubtramiteConfig(key);
  const subtramite = extractSubtramiteFromTramite(subtramiteConfig, tramite);
  return mapSubtramite(subtramiteConfig, subtramite);
}
